import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.authorization}users/userProfile`;

export interface DeleteUserProfileCommandArgs {
  userProfileId: string;
}

export const deleteUserProfileRequest = (
  payload: DeleteUserProfileCommandArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.DELETE, json: payload },
});

export const deleteUserProfileCommand = async (
  payload: DeleteUserProfileCommandArgs,
): Promise<BackResponse<void> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<void>>(
      deleteUserProfileRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
